import { useEffect, useState } from "react";

let current = null;
const listeners = new Set();

export const setAISpot = (spot) => {
  current = spot;
  listeners.forEach((l) => l(spot));
};

export const openAssistant = () => window.dispatchEvent(new Event("open-ai-assistant"));

export const useAISpot = () => {
  const [spot, setSpot] = useState(current);
  useEffect(() => {
    listeners.add(setSpot);
    return () => listeners.delete(setSpot);
  }, []);
  return spot;
};

export const spotContext = (s) =>
  `\n\nLe visiteur consulte actuellement ce spot. Utilise ces informations pour adapter tes conseils :\n` +
  `- Nom : ${s.name} (${s.department}, ${s.region})\n` +
  `- Type d'eau : ${s.water_type}\n` +
  `- Espèces présentes : ${s.fish.join(", ")}\n` +
  `- Meilleure saison : ${s.best_season}\n` +
  `- Niveau : ${s.difficulty}\n` +
  `- Description : ${s.description}\n` +
  `- Conseil du guide : ${s.tips}\n` +
  `- Nous sommes en ${new Date().toLocaleDateString("fr-FR", { month: "long" })}.\n` +
  `Ne parle que des espèces présentes sur ce spot, sauf si on te demande autre chose.`;
